module.exports = __webpack_public_path__ + "static/media/logo-go.b4d61186.png";